import { apiClient } from '../../client'
import { useGenericRequestHandler } from '../../handlers/useGenericRequestHandler'

const ENDPOINT = 'v1/u/nativeForm'

export const useNativeFormMutation = () => {
  return useGenericRequestHandler({
    route: ENDPOINT,
    method: 'POST'
  })
}

export function sendNativeFormRaw(variables = {}) {
  return apiClient
    .post(ENDPOINT, {
      json: variables
    })
    .then(response => response.json())
    .catch(error => ({ error }))
}
